import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { ApiService } from '../../../services/api_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { generateExcelFilter } from '../../../core/table/filter/GenerateExcelFilter';

interface DatenverwaltungNaceProps extends React.ClassAttributes<any> {
    data: any;
}

interface DatenverwaltungNaceState {
    wzData: Array<any>;
    refreshCnt: number;
}

export class DatenverwaltungNace extends React.Component<DatenverwaltungNaceProps, DatenverwaltungNaceState> {

    constructor(props: any) {
        super(props);
        this.state = {
            wzData: null,
            refreshCnt: 0
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.bundleFilterFunc = this.bundleFilterFunc.bind(this);

        this.bereichKey = this.apiService.getBereichKey();
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(ApiService) private apiService: ApiService;

    private bereichKey: string;

    render(): JSX.Element {
        const { wzData, refreshCnt } = this.state;

        const excelFilter = (accessor: string) => {
            return ({ filter, onChange }: { filter: any, onChange: any }) =>
                generateExcelFilter(accessor, onChange, null, () => { return wzData || []; }, 'CHAR191');
        };
        const excelFilterMethod = (accessor: string) => {
            return (filter: any, row: any) => {
                return (filter.value.indexOf(row[accessor]) !== -1);
            };
        };
        const customColumns: Array<any> = [
            {
                index: 0,
                accessor: 'bereich',
                Header: 'Bereich',
                id: 'bereich',
                type: 'text',
                Filter: excelFilter('bereich'),
                filterMethod: excelFilterMethod('bereich')
            }
        ];

        return (
            <div>
                <WFormsTableWrapper
                    key={IDs.ENT_GEWERKE_WZ + refreshCnt}
                    entity={IDs.ENT_GEWERKE_WZ}
                    module={IDs.MOD_ETOOL_ADMIN}
                    data={wzData}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    customColumns={customColumns}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_GEWERKE_WZ)}
                    onDataLoaded={this.onDataLoaded}
                    bundleFilterFunc={this.bundleFilterFunc}
                />
            </div>
        );
    }

    onDataLoaded(wzData: Array<any>) {
        const { refreshCnt } = this.state;
        const gewerkMap: any = {};
        (this.props.data[IDs.ENT_BRANCHEN_GEWERKE] || []).forEach((r: any) => {
            gewerkMap[r.tid] = r;
        });
        if (Array.isArray(wzData)) {
            wzData.forEach((r: any) => {
                const gewerk = gewerkMap[r.gewerk_tid_orig] || {};
                r.bereich = gewerk.bereich_key;
                r.bereich_orig = gewerk.bereich_key_orig;
            });
            if (this.bereichKey !== 'all') {
                wzData = wzData.filter((r: any) => r.bereich_orig === this.bereichKey);
            }
            this.setState({ wzData, refreshCnt: refreshCnt + 1 });
        }
    }

    bundleFilterFunc(bundle: any) {
        if (this.bereichKey !== 'all') {
            bundle.gewerk_tid = bundle.gewerk_tid.filter((r: any) => r.bereich_key_orig === this.bereichKey);
        }
        return bundle;
    }
}
